import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useState } from 'react'

let idIndex = 0

const TextArea = ({
  id,
  name,
  className,
  value = '',
  onValueChange,
  placeholder,
  maxLength,
  error,
  disabled,
  trim,
}) => {
  const [isFocused, setFocus] = useState(false)
  const [idx] = useState(idIndex++)

  return (
    <div
      className={classNames(className, {
        on: isFocused,
        on_inp: !isFocused && value.length > 0,
        in_active: disabled,
        in_error: error,
      })}>
      <label htmlFor={id || `tfArea${idx}`} className="lab_txt">
        {placeholder}
      </label>
      <span className="num_byte">
        <span className="screen_out">작성가능한 총 텍스트 수</span>
        {maxLength - value.length}
      </span>
      <textarea
        id={id || `tfArea${idx}`}
        name={name}
        className="tf_area"
        value={value}
        maxLength={maxLength}
        onKeyDown={e => {
          if (e.target.value.length > maxLength) {
            e.target.value = e.target.value.substring(0, maxLength)
          }
        }}
        onFocus={() => setFocus(true)}
        onBlur={e => {
          if (trim) {
            e.target.value = e.target.value.trim()
          }
          onValueChange(e.target.value)
          setFocus(false)
        }}
        onChange={e =>
          onValueChange(
            e.target.value.replace(/\n/g, '').substring(0, maxLength)
          )
        }
        disabled={disabled}
      />
    </div>
  )
}

export default TextArea

TextArea.propTypes = {
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  id: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onValueChange: PropTypes.func,
  value: PropTypes.string,
  trim: PropTypes.bool,
}
